import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { Box, Typography, Avatar } from "@material-ui/core";
import { config } from "../../../config";
import GoogleMapReact from "google-map-react";
import { useTranslate } from "../../../Hooks";
import { MapMarkerIcon } from "../../../assets/icons";
import { getDownloadableLink } from "../../../Helper";

// styles
import useStyles from "./styles";

export const GoogleMapsStyles = {
  gray: [
    {
      stylers: [
        { saturation: -100 },
        { gamma: 0.8 },
        { lightness: 4 },
        { visibility: "on" },
      ],
    },
  ],
};

const InfoWindow = ({ propretyResponseJson }) => {
  const styles = useStyles();
  const { translate } = useTranslate("NewPropertiesView")
  return (
    <Box className={styles.infoWindow}>
      <Box>
        <Typography className={styles.titleInfo}>
          {translate("Owner")}
        </Typography>
        <Typography className={styles.title}>
          {propretyResponseJson?.property?.property_owner?.name || "N/A"}
        </Typography>
      </Box>
      <Box className={styles.containerRowInfo}>
        <Typography className={styles.titleInfo}>
          {translate("Owner-representative-person")}
        </Typography>
        <Box className={styles.containerAvatarName}>
          <Avatar
            className={clsx({
              [styles.AvatarStyle]:
                propretyResponseJson?.property?.owner_representative_person
                  ?.fileId,
              [styles.defaultAvatarWithNameStyle]:
                !propretyResponseJson?.property?.owner_representative_person
                  ?.fileId &&
                propretyResponseJson?.property?.owner_representative_person
                  ?.name,
            })}
            src={
              propretyResponseJson?.property?.owner_representative_person
                ?.fileId
                ? getDownloadableLink(
                    propretyResponseJson?.property?.owner_representative_person
                      ?.fileId
                  )
                : null
            }
          >
            {!propretyResponseJson?.property?.owner_representative_person
              ?.fileId &&
            propretyResponseJson?.property?.owner_representative_person?.name
              ? propretyResponseJson?.property?.owner_representative_person?.name
                  .slice(0, 2)
                  .toUpperCase()
              : null}
          </Avatar>
          <Typography className={styles.title}>
            {propretyResponseJson?.property?.owner_representative_person
              ?.name || "N/A"}
          </Typography>
        </Box>
      </Box>
      <Box className={styles.containerRowInfo}>
        <Typography className={styles.titleInfo}>
          {translate("Property-managed-by")}
        </Typography>
        <Box className={styles.containerAvatarName}>
          <Avatar
            className={clsx({
              [styles.AvatarStyle]:
                propretyResponseJson?.property?.property_managed_by?.name,
              [styles.defaultAvatarWithNameStyle]:
                !propretyResponseJson?.property?.property_managed_by?.fileId &&
                propretyResponseJson?.property?.property_managed_by?.name,
            })}
            src={
              propretyResponseJson?.property?.property_managed_by?.fileId
                ? getDownloadableLink(
                    propretyResponseJson?.property?.property_managed_by?.fileId
                  )
                : null
            }
          >
            {!propretyResponseJson?.property?.property_managed_by?.fileId &&
            propretyResponseJson?.property?.property_managed_by?.name
              ? propretyResponseJson?.property?.property_managed_by?.name
                  .slice(0, 2)
                  .toUpperCase()
              : null}
          </Avatar>
          <Typography className={styles.title}>
            {propretyResponseJson?.property?.property_managed_by?.name || "N/A"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

function PropertyLocationMap({
  defaultCenter,
  location: _location,
  locations,
  propretyResponseJson,
  defaultZoom,
}) {
  const styles = useStyles();
  const [google, setGoogle] = useState(null);
  const [infoWindow, setInfoWindow] = useState(null);
  const [currentLocations, setCurrentLocations] = useState(locations);
  const [StyleMode, setStyleMode] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const handleMap = (map, maps) => {
    setGoogle({ map, maps });

    if (!infoWindow) {
      const newInfoWindow = new maps.InfoWindow();
      setInfoWindow(newInfoWindow);
    }

    if (currentLocations.length > 0) {
      const bounds = new maps.LatLngBounds();
      currentLocations.forEach((location) => {
        bounds.extend(new maps.LatLng(location.latitude, location.longitude));
      });
      map.fitBounds(bounds);
      map.setZoom(map.getZoom() - 5);
    }
  };

  const mapOptions = {
    scrollwheel: true,
    zoomControlOptions: {
      style: "SMALL",
    },
    mapTypeControlOptions: {
      mapTypeIds: ["roadmap", "satellite", "hybrid", "terrain", "map"],
    },
    types: ["hospital", "health"],
    draggable: true,
    panControl: true,
    zoomControl: true,
    mapTypeControl: true,
    rotateControl: true,
    scaleControl: true,
    styles: StyleMode,
    streetViewControl: true,
    libraries: ["places", "geometry", "drawing", "visualization"],
    overviewMapControl: true,
  };

  useEffect(() => {
    setSelectedLocation(locations?.[0]);
  }, []);

  useEffect(() => {
    setStyleMode(GoogleMapsStyles.gray);
  }, []);

  return (
    <Box className={styles.wrapperGoogleMap}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: config.GoogleMapApiKey }}
        defaultCenter={defaultCenter}
        defaultZoom={defaultZoom}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) => handleMap(map, maps)}
        options={mapOptions}
      >
        {locations.map((loc, index) => (
          <div key={index} lat={loc.latitude} lng={loc.longitude}>
            <MapMarkerIcon
              width="176.284"
              height="176.284"
              onClick={() => setSelectedLocation(loc)}
              style={{ cursor: "pointer", transform: "translate(-50%, -50%)" }}
            />

            {selectedLocation?.latitude === loc.latitude &&
              selectedLocation?.longitude === loc.longitude && (
                <div className={styles.infoWindowContainer}>
                  <InfoWindow
                    propretyResponseJson={propretyResponseJson}
                  />
                </div>
              )}
          </div>
        ))}
      </GoogleMapReact>
    </Box>
  );
}

export default PropertyLocationMap;

PropertyLocationMap.defaultProps = {
  defaultCenter: { lat: 24.414833592365972, lng: 54.59777364239554 },
  hoverDistance: 30,
  defaultZoom: 10,
  onClick: undefined,
  onChange: undefined,
  hideLatitudeLongitude: false,
  center: undefined,
  searchLocationValue: null,
  viewLocationOnly: false,
};
